module.exports = __webpack_public_path__ + "4723e66cc73573cd416daee86f0ce095.png";